// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5823":"703719903c","6997":"a3a7b63afd"}[chunkId] + ".chunk.css";
};